import React from "react";
import { useStyles } from "./BasketDetail.styles";

interface Props {}

export const BasketDetail: React.FC<Props> = () => {
  const classes = useStyles();
  return <div className={classes.basketDetail_root}>Basket Detail</div>;
};
